import lozad from 'lozad'

const observer = lozad(); 
observer.observe();